<template>
  <!-- Buyer data -->
  <b-row v-if="buyer && localLoading === false">
    <b-col
      lg="3"
      md="4"
    >
      <validation-provider
        #default="{ errors }"
        name="Buyer name"
        rules="required"
      >
        <label>Buyer name</label>
        <b-form-input
          v-model="buyer.name"
          v-b-tooltip.hover.top="getIssueMessage('buyer.name')"
          :class="getIssueClass('buyer.name')"
          :disabled="disabled"
          class="mr-0 ml-0"
          :state="errors.length > 0 ? false:null"
        />
      </validation-provider>
    </b-col>

    <b-col
      lg="3"
      md="4"
    >
      <validation-provider
        #default="{ errors }"
        name="Buyer registry number"
        :rules="parcel.declaration_type === 'H1' ? 'required' : ''"
      >
        <label>Buyer registry number</label>
        <b-form-input
          v-model="buyer.registry_number"
          v-b-tooltip.hover.top="getIssueMessage('buyer.registry_number')"
          :class="getIssueClass('buyer.registry_number')"
          :disabled="disabled"
          class="mr-0 ml-0"
          :state="errors.length > 0 ? false:null"
        />
      </validation-provider>
    </b-col>

    <b-col
      lg="3"
      md="4"
    >
      <validation-provider
        #default="{ errors }"
        name="Buyer street number"
        rules="required"
      >
        <label>Buyer street number</label>
        <b-form-input
          v-model="buyer.street_and_number"
          v-b-tooltip.hover.top="getIssueMessage('buyer.street_and_number')"
          :class="getIssueClass('buyer.street_and_number')"
          :disabled="disabled"
          class="mr-0 ml-0"
          :state="errors.length > 0 ? false:null"
        />
      </validation-provider>
    </b-col>

    <b-col
      lg="3"
      md="4"
    >
      <validation-provider
        #default="{ errors }"
        name="Buyer postal code"
        rules="required|max:20"
      >
        <label>Buyer postal code</label>
        <b-form-input
          v-model="buyer.postal_code"
          v-b-tooltip.hover.top="getIssueMessage('buyer.postal_code')"
          :class="getIssueClass('buyer.postal_code')"
          :disabled="disabled"
          class="mr-0 ml-0"
          :state="errors.length > 0 ? false:null"
        />
      </validation-provider>
    </b-col>

    <b-col
      lg="3"
      md="4"
    >
      <validation-provider
        #default="{ errors }"
        name="Buyer city"
        rules="required"
      >
        <label>Buyer city</label>
        <b-form-input
          v-model="buyer.city"
          v-b-tooltip.hover.top="getIssueMessage('buyer.city')"
          :class="getIssueClass('buyer.city')"
          :disabled="disabled"
          class="mr-0 ml-0"
          :state="errors.length > 0 ? false:null"
        />
      </validation-provider>
    </b-col>

    <b-col
      lg="3"
      md="4"
    >
      <label>Buyer region</label>
      <b-form-input
        v-model="buyer.region"
        v-b-tooltip.hover.top="getIssueMessage('buyer.region')"
        :class="getIssueClass('buyer.region')"
        :disabled="disabled"
        class="mr-0 ml-0"
      />
    </b-col>

    <b-col
      lg="3"
      md="4"
    >
      <validation-provider
        #default="{ errors }"
        name="Buyer country"
        rules="required|min:2|max:2|alpha"
      >
        <label>Buyer country</label>
        <b-form-input
          v-model="buyer.country"
          v-b-tooltip.hover.top="getIssueMessage('buyer.country')"
          :class="getIssueClass('buyer.country')"
          :disabled="disabled"
          class="mr-0 ml-0"
          :state="errors.length > 0 ? false:null"
        />
      </validation-provider>
    </b-col>

    <b-col
      lg="3"
      md="4"
    >
      <label>Buyer email</label>
      <b-form-input
        v-model="buyer.email"
        v-b-tooltip.hover.top="getIssueMessage('buyer.email')"
        :class="getIssueClass('buyer.email')"
        :disabled="disabled"
        class="mr-0 ml-0"
      />
    </b-col>

    <b-col
      lg="3"
      md="4"
    >
      <label>Buyer phone</label>
      <b-form-input
        v-model="buyer.phone"
        v-b-tooltip.hover.top="getIssueMessage('buyer.phone')"
        :class="getIssueClass('buyer.phone')"
        :disabled="disabled"
        class="mr-0 ml-0"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import { EventBus } from '@core/utils/utils'
import errorHighlightingMixin from '@/mixins/errorHighlightingMixin'

export default {
  components: {
    ValidationProvider,
    BRow,
    BCol,
    BFormInput,
  },
  mixins: [errorHighlightingMixin],
  props: {
    parcel: {
      type: Object,
      required: true,
      default: () => {},
    },
    disabled: {
      type: Boolean,
    },
    companyId: {
      type: Number,
      required: true,
    },
    shipmentId: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      required,
      buyer: {},
      localLoading: this.loading,
    }
  },
  watch: {
    loading(newVal) {
      this.localLoading = newVal
    },
  },
  created() {
    this.fetchBuyerData()
  },
  methods: {
    fetchBuyerData() {
      this.$http.get(`/v1/companies/${this.companyId}/shipments/${this.shipmentId}/parcels/${this.parcel.id}/buyer-data`)
        .then(response => {
          this.buyer = response.data.buyer
          this.localLoading = false
          EventBus.$emit('update-buyer', this.buyer)
          EventBus.$emit('buyer-data-loader', false)
        })
    },
  },
}
</script>

<style scoped lang="scss">
@import '@core/scss/base/bootstrap-extended/variables';

.input-warning {
  background: lighten($warning, 35%);
  border: 1px solid $warning;
}
.input-danger {
  background: lighten($danger, 30%);
  border: 1px solid $danger;
}
</style>
